var DATA_URI_PATTERN = /^data:(\S*?)?(;charset=[^;]+)?(;[^,]+?)?,(.+)/;

function isDataUriResource(uri) {
  return DATA_URI_PATTERN.test(uri);
}

module.exports = isDataUriResource;



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/lib/utils/is-data-uri-resource.js
// module id = 2325
// module chunks = 0